import PlaceFilled from '@alltrails/denali/icons/PlaceFilled';
import { COLOR_MAP_WAYPOINT_USER } from '@alltrails/denali/tokens';
import { POIPinSize, createIconPinSvg } from './svgMarkerComponents';

const createWaypointPinSvg = (size: POIPinSize) => createIconPinSvg(`waypoint-${size}`, PlaceFilled, size, COLOR_MAP_WAYPOINT_USER);

export default createWaypointPinSvg;
